import SEO from "@/components/SEO";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-zinc-300">
      <SEO title="Terms of Service — SourceDeck" description="SourceDeck Terms of Service. Governed by Indian law." path="/terms" />
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-16 md:py-24">
        <a href="/" className="sd-label mb-8 inline-block hover:text-white transition-colors" data-testid="legal-back-home">← BACK TO SOURCEDECK</a>
        <div className="sd-label mb-3 text-[#FF3B30]">● LEGAL</div>
        <h1 className="font-display text-5xl md:text-6xl leading-tight tracking-tight mb-4">Terms of Service</h1>
        <div className="font-mono text-xs text-zinc-500 mb-12">Last updated: February 2026 · Effective immediately upon account creation</div>

        <div className="prose prose-invert space-y-6 leading-relaxed">
          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">1. Acceptance</h2>
            <p>By creating a SourceDeck account or using the service, you agree to these Terms. If you do not agree, do not use SourceDeck. SourceDeck is operated by an individual/entity based in India ("we", "us", "SourceDeck").</p>
          </section>
          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">2. The Service</h2>
            <p>SourceDeck is a creator workspace providing script drafting, sponsor tracking, analytics, AI-assisted content repurposing, and third-party integrations (Google/YouTube, Spotify). Features are subject to your subscription tier (Free, Solo, Pro, Studio).</p>
          </section>
          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">3. Account & Eligibility</h2>
            <p>You must be at least 18 years old and legally capable of entering a binding contract. You are responsible for keeping your Google account credentials safe. You may not share your account.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">4. Acceptable Use</h2>
            <p>You will not: (a) upload content that infringes any third party's rights; (b) use SourceDeck to generate spam, deceptive, or unlawful outreach; (c) attempt to reverse-engineer, scrape, or overload the service; (d) resell SourceDeck without written permission.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">5. AI-Generated Content</h2>
            <p>AI outputs (Fit Score, pitch emails, repurposed content) are generated by third-party language models. You are responsible for reviewing every AI output before sending, publishing, or acting on it. SourceDeck does not warrant that AI outputs are accurate, appropriate, or fit for any particular purpose.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">6. Third-Party Data & Integrations</h2>
            <p>When you connect Google (YouTube, Drive) or Spotify, SourceDeck reads data through their official APIs subject to their terms. We do not sell or share this data. You may disconnect at any time from the Analytics page.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">7. Payments & Subscriptions</h2>
            <p>Paid plans renew every 30 days from the date of purchase unless cancelled. Payments are processed by Razorpay in Indian Rupees (INR). See our <a href="/refund" className="text-[#FF3B30] hover:underline">Refund & Cancellation Policy</a> for details.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">8. Intellectual Property</h2>
            <p>Your content stays yours. The SourceDeck software, brand, and design are ours. By using SourceDeck you grant us a limited license to process your content solely to provide the service.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">9. Termination</h2>
            <p>You may delete your account at any time by contacting support. We may suspend or terminate accounts that violate these Terms, with reasonable notice where possible.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">10. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, SourceDeck's total liability in any 12-month period is capped at the fees you paid in that period. We are not liable for lost profits, lost data, or indirect damages.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">11. Governing Law</h2>
            <p>These Terms are governed by the laws of India. Disputes will be resolved in the courts of Bengaluru, Karnataka.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">12. Contact</h2>
            <p>Questions? See our <a href="/contact" className="text-[#FF3B30] hover:underline">Contact page</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
